import React, { useState } from "react";
import { Button, Stack, Snackbar } from "@mui/material";

import { setToast } from "../redux/actions/ToastAction";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../components/alert";

import ConfirmMain from "./ConfirmMain";
import ConfirmationURL from "./ConfirmURL";
const Confirmation = () => {

  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  // tabs
  const [value, setValue] = useState(0);

  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>

      <Stack direction="row" spacing={2}>
        <Button
          variant={value === 0 ? "contained" : "outlined"}
          style={{
            background: value === 0 ? "var(--main-color)" : "",
            fontWeight: value === 0 ? "bold" : "normal",
            padding: "8px 18px",
            borderRadius: "40px",
          }}
          onClick={() => setValue(0)}
        >
          Контекстная реклама
        </Button>
        <Button
          variant={value === 1 ? "contained" : "outlined"}
          style={{
            background: value === 1 ? "var(--main-color)" : "",
            fontWeight: value === 1 ? "bold" : "normal",
            padding: "12px 22px",
            borderRadius: "40px",
          }}
          onClick={() => setValue(1)}
        >
          Пост реклама
        </Button>
      </Stack>
      {value === 1 ? <ConfirmMain /> : <ConfirmationURL />}
    </div>
  );
};

export default Confirmation;
